import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { BackendCallService } from 'src/app/services/backend-call/backend-call.service';
import { ToastService } from 'src/app/services/toast.service';
import { AppConstants } from 'src/app/utilities/constant';

@Component({
  selector: 'app-pictogram-library',
  templateUrl: './pictogram-library.component.html',
  styleUrls: ['./pictogram-library.component.scss'],
})
export class PictogramLibraryComponent implements OnInit {
  @Input() existingPictogramIds: string[] = [];

  categories: any[] = [];
  selectedCategory: any = null;
  displayedImages: any[] = [];
  selectedImages: Map<string, any> = new Map();
  isLoading = false;

  constructor(
    private modalController: ModalController,
    private backendService: BackendCallService,
    private toastService: ToastService,
    private translate: TranslateService,
    private changeDetectorRef: ChangeDetectorRef,
  ) {}

  ngOnInit() {
    this.loadCategories();
  }

  private loadCategories() {
    this.isLoading = true;
    this.backendService.getPictogramCategoriesList().subscribe(
      (res: any) => {
        this.categories = res?.response || [];
        // Enrich each image with categoryName from parent category
        this.categories.forEach(cat => {
          (cat.images || []).forEach(img => {
            img.categoryName = cat.name;
          });
        });
        if (this.categories.length > 0) {
          this.selectedCategory = this.categories[0];
          this.displayedImages = this.selectedCategory.images || [];
        }
        this.isLoading = false;
        this.changeDetectorRef.detectChanges();
      },
      (err) => {
        this.isLoading = false;
        this.toastService.presentToast(
          this.translate.instant('failed_to_load_pictogram_categories'),
          4000,
          AppConstants.ERROR_SNACKBAR,
          'top'
        );
        this.changeDetectorRef.detectChanges();
      }
    );
  }

  onCategoryChange(category: any) {
    this.selectedCategory = category;
    this.displayedImages = category?.images || [];
  }

  toggleImageSelection(image: any) {
    if (this.isAlreadyAdded(image)) {
      return;
    }

    if (this.selectedImages.has(image.id)) {
      this.selectedImages.delete(image.id);
    } else {
      this.selectedImages.set(image.id, image);
    }
    this.changeDetectorRef.detectChanges();
  }

  onCheckboxKeydown(event: KeyboardEvent): void {
    const key = event.key;
    if ( key !== ' ' && key !== 'Spacebar') {
      return;
    }

    event.preventDefault();
    event.stopPropagation();
    (event.currentTarget as HTMLElement | null)?.click();
  }

  isSelected(image: any): boolean {
    return this.selectedImages.has(image.id);
  }

  isAlreadyAdded(image: any): boolean {
    return this.existingPictogramIds.includes(image.id);
  }

  handleImageError(event: Event) {
    const img = event.target as HTMLImageElement;
    img.src = 'assets/images/Machine Library.svg';
  }

  upload() {
    const selected = Array.from(this.selectedImages.values());
    this.modalController.dismiss({ selectedImages: selected });
  }

  close() {
    this.modalController.dismiss();
  }
}
